import { Children, isValidElement, ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import { NavigationSectionProps } from './NavigationSection';

interface NavigationCategoryProps {
  /**
   * The title of the category.
   */
  title: ReactNode;
  /**
   * An array of NavigationSection components.
   */
  children?: ReactNode;
}
/**
 * Component that renders a category and accept NavigationSection as children.
 */
export function NavigationCategory({
  children,
  title,
}: NavigationCategoryProps) {
  const hasEnabledSections = Children.toArray(children).some((child) => {
    if (isValidElement<NavigationSectionProps>(child)) {
      return child.props.isVisible ?? true;
    }
    return false;
  });

  if (!hasEnabledSections) {
    return null;
  }

  return (
    <Flex flexDirection="column" gap="space-8">
      {title}
      <Flex flexDirection="column">{children}</Flex>
    </Flex>
  );
}

interface NavigationCategoryTitleProps {
  children: ReactNode;
}

NavigationCategory.Title = function Title({
  children,
}: NavigationCategoryTitleProps) {
  return (
    <Text
      color="grey.800"
      fontWeight="weight-500"
      paddingLeft="space-16"
      size="xs"
    >
      {children}
    </Text>
  );
};
